import styled from 'styled-components';
import { Button } from 'components/elements';
import { colors, media, fontSize, fontWeight } from 'settings/style';
import { SurfaceCard } from '../index.styled';

export const DailyNotesCard = styled(SurfaceCard)`
  margin-top: 16px;
  padding: 18px;
`;

export const DailyNotesHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;

  ${media.md`
    flex-direction: column;
    align-items: stretch;
  `}
`;

export const DailyNotesTitle = styled.div`
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 22px;
  font-weight: 500;
  color: ${colors.grey900};
`;

export const DailyNotesTitleRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
`;

/** Dated header of an actual note — a day with no note carries no date. */
export const NoteDate = styled.div`
  font-size: 13px;
  font-weight: ${fontWeight.bold};
  color: ${colors.grey900};
  margin-bottom: 8px;
`;

export const DailyNotesPasscode = styled.div`
  font-size: 15px;
  color: ${colors.grey900};
  margin-top: 0.5rem;
`;

export const DailyNotesActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;

  ${media.md`
    justify-content: start;
    width: 100%;
    flex-wrap: nowrap;
    gap: 8px;
  `}
`;

export const IconButton = styled(Button)`
  height: 34px !important;
  min-height: 34px !important;
  width: 34px;
  padding: 0 !important;
  border-radius: 10px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const PrimaryIconButton = styled(IconButton)`
  background: ${colors.primary500} !important;
  border-color: ${colors.primary500} !important;
  color: ${colors.primary800} !important;
`;

export const ContentBox = styled.div`
  background: ${colors.grey200};
  border: 1px solid ${colors.cardBorder};
  border-radius: 12px;
  padding: 14px;

  textarea {
    background: transparent;
    border-radius: 10px !important;
  }
`;

export const ContentText = styled.div`
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 1.6;
  color: #344054;
`;

export const SaveRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
`;

export const DateHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ArrowButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const TextButton = styled(Button)`
  height: 34px !important;
  min-height: 34px !important;
  border-radius: 10px !important;
  font-size: ${fontSize.sm};
  padding: 0 14px !important;
  font-weight: ${fontWeight.bold};

  ${media.md`
    padding: 0 10px !important;
    font-size: 13px;
    white-space: nowrap;
  `}
`;

